export const BROADCAST_STATE_KEY = 'travel_broadcast_state';

import { readJSONFromLocalStorage, writeJSONToLocalStorage } from '../consent/localStorage';

interface BroadcastStateElement {
    id: number;
    timeout: number;
}

const getBroadcastState = (): BroadcastStateElement[] => {
    const storage = readJSONFromLocalStorage<BroadcastStateElement[]>(BROADCAST_STATE_KEY);
    return Array.isArray(storage) ? storage : [];
};

interface BroadcastMessage {
    id: number;
    message: string;
}

export const filterDismissedBroadcasts = (messages: BroadcastMessage[]): BroadcastMessage[] => {
    const dismissed = getBroadcastState().map((entry) => entry.id);

    return messages.filter((message) => !dismissed.includes(message.id));
};

export const dismissBroadcast = (broadcastId: number) => {
    const currentState = getBroadcastState();

    currentState.push({
        id: broadcastId,
        timeout: Date.now() + 1209600000, // two weeks
    });

    writeJSONToLocalStorage(BROADCAST_STATE_KEY, currentState);
};

export const purgeOutdatedBroadcasts = () =>
    writeJSONToLocalStorage(
        BROADCAST_STATE_KEY,
        getBroadcastState().filter((entry) => entry.timeout > Date.now()),
    );
